import { getPictureGalleryParameters } from './selectors';

export default function mapStateToProps(state) {
    const parameters = getPictureGalleryParameters(state);

    return {
        visible: parameters.showPictures,
        current: parameters.currentPicture,
        pictures: parameters.pictures,
    };
}
